import { Box, Grid, Paper, Typography } from '@mui/material';

import React from 'react';
import {
  AppFormikCheckbox,
  AppFormikCheckboxGroup,
  AppFormikTextArea,
  AppFormikTextField,
} from 'shared/components/AppComponents';

const MCPSpecificDetails: React.FC<any> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { purpose } = props;
  console.log(purpose);
  return (
    <Box className="paper-form-content">
      <Paper variant="outlined">
        <Typography variant="h6">MCP-Specific Details</Typography>
        <Box className="paper-form-input-content">
          <Grid spacing={4} container className="paper-form-label-input-grid">
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="mcp_server_type"
                placeholder="Enter mcp server type"
                outerLabel
                label="MCP Server Type"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="protocol_version"
                placeholder="Enter protocol version"
                outerLabel
                label="Protocol / Version Supported"
              />
            </Grid>
            <Grid item xs={12}>
              <Box>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                  mb={2}
                >
                  Transport Methods
                </Typography>
                <AppFormikCheckboxGroup
                  name="transport_methods"
                  outerLabel=""
                  options={[
                    { label: 'stdio', value: 'stdio' },
                    { label: 'SSE', value: 'SSE' },
                    { label: 'streamable HTTP', value: 'streamable HTTP' },
                  ]}
                  row
                  sx={{
                    width: 'auto',
                  }}
                />
              </Box>
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="server_endpoint"
                placeholder="Enter server endpoint / distribution"
                outerLabel
                label="Server Endpoint / Distribution"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="version"
                placeholder="Enter version"
                outerLabel
                label="Version"
              />
            </Grid>
            <Grid item xs={12}>
              <AppFormikTextArea
                name="tool_inventory_summary"
                placeholder="Enter tool inventory summary"
                label="Tool Inventory Summary"
                outerLabel
                rows={3}
                inputProps={{
                  style: { resize: 'vertical' },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <AppFormikTextArea
                name="resource_inventory_summary"
                placeholder="Enter resource inventory summary"
                label="Resource Inventory Summary"
                outerLabel
                rows={3}
                inputProps={{
                  style: { resize: 'vertical' },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <AppFormikTextArea
                name="prompt_template_capabilities"
                placeholder="Enter prompt template capabilities"
                label="Prompt/Template Capabilities"
                outerLabel
                rows={3}
                inputProps={{
                  style: { resize: 'vertical' },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <AppFormikCheckbox
                name="supports_multi_tenant"
                label="Supports Multi-Tenant Use"
                outerLabel=""
              />
            </Grid>
            <Grid item xs={12}>
              <AppFormikTextArea
                name="client_compatibility_notes"
                placeholder="Enter client compability notes"
                label="Client Compability Notes"
                outerLabel
                rows={3}
                inputProps={{
                  style: { resize: 'vertical' },
                }}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="release_channel"
                placeholder="Enter release channel"
                outerLabel
                label="Release Channel"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="change_log_link"
                placeholder="Enter change log link"
                outerLabel
                label="Change Log Link"
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default MCPSpecificDetails;
